import * as React from 'react';
import { FormItemContext } from './form';

export const FormItem = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
    const id = React.useId();

    return (
        <FormItemContext.Provider value={{ id }}>
            <div ref={ref} className={'space-y-2'} {...props} />
        </FormItemContext.Provider>
    );
});

FormItem.displayName = 'FormItem';
